/**
 * Collection Load More Functionality
 * Gère le chargement progressif des produits dans les pages de collection
 */
class CollectionLoadMore {
  constructor() {
    this.productGrid = document.getElementById("product-grid");
    this.loadMoreBtn = document.getElementById("load-more-btn");
    this.loadMoreContainer = document.getElementById("load-more-container");
    this.productsCounter = document.getElementById("products-counter");
    this.paginationData = this.getPaginationData();

    if (!this.productGrid || !this.paginationData) {
      return;
    }

    this.currentPage = this.paginationData.currentPage;
    this.totalPages = this.paginationData.totalPages;
    this.totalProducts = this.paginationData.totalProducts;
    this.productsPerPage = this.paginationData.productsPerPage;
    this.baseUrl = this.paginationData.baseUrl;
    this.isAllProducts = this.paginationData.isAllProducts;
    this.collectionHandle = this.productGrid.dataset.collectionHandle;
    this.isLoading = false;

    this.init();
  }

  getPaginationData() {
    const paginationElement = document.getElementById("pagination-data");
    if (!paginationElement) return null;

    try {
      return JSON.parse(paginationElement.textContent);
    } catch (error) {
      console.error("Erreur lors du parsing des données de pagination:", error);
      return null;
    }
  }

  init() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener("click", () => this.loadMoreProducts());
    }
    this.updateLoadMoreButton();
    this.updateProductsCounter();
  }

  updateLoadMoreButton() {
    if (!this.loadMoreContainer) return;

    if (this.currentPage >= this.totalPages) {
      this.loadMoreContainer.style.display = "none";
    } else {
      this.loadMoreContainer.style.display = "block";
      if (this.loadMoreBtn) {
        this.loadMoreBtn.textContent = "Charger plus de produits";
        this.loadMoreBtn.disabled = false;
      }
    }
  }

  updateProductsCounter() {
    if (!this.productsCounter) return;

    const currentlyDisplayed = Math.min(
      this.currentPage * this.productsPerPage,
      this.totalProducts
    );
    this.productsCounter.textContent = `${currentlyDisplayed} sur ${this.totalProducts} produits affichés`;
  }

  async loadMoreProducts() {
    if (
      this.isLoading ||
      this.currentPage >= this.totalPages ||
      !this.loadMoreBtn
    ) {
      return;
    }

    this.setLoadingState(true);

    try {
      const nextPage = this.currentPage + 1;

      // URL adaptée selon le contexte
      let nextUrl;
      if (this.isAllProducts) {
        nextUrl = `/collections/all?page=${nextPage}&view=products`;
      } else {
        const separator = this.baseUrl.includes("?") ? "&" : "?";
        nextUrl = `${this.baseUrl}${separator}page=${nextPage}&view=products`;
      }

      const response = await fetch(nextUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      this.appendProducts(html);

      this.currentPage = nextPage;
      this.updateLoadMoreButton();
      this.updateProductsCounter();
    } catch (error) {
      console.error("Erreur lors du chargement des produits:", error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  appendProducts(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const newProducts = tempDiv.querySelectorAll(".product-column");

    if (newProducts.length === 0) {
      console.warn("Aucun nouveau produit trouvé dans la réponse");
      return;
    }

    newProducts.forEach((product) => {
      const productClone = product.cloneNode(true);
      this.productGrid.appendChild(productClone);
    });
  }

  setLoadingState(loading) {
    if (!this.loadMoreBtn) return;

    this.isLoading = loading;

    if (loading) {
      this.loadMoreBtn.textContent = "Chargement...";
      this.loadMoreBtn.disabled = true;
    } else {
      this.loadMoreBtn.textContent = "Charger plus de produits";
      this.loadMoreBtn.disabled = false;
    }
  }

  showError() {
    if (!this.loadMoreBtn) return;

    this.loadMoreBtn.textContent = "Erreur - Réessayer";
    this.loadMoreBtn.disabled = false;
  }
}

// Initialisation automatique quand le DOM est prêt
document.addEventListener("DOMContentLoaded", function () {
  new CollectionLoadMore();
});
